module.exports = __webpack_public_path__ + "media/images/homepage/reason-4-7199257e951a1cfb33af2a8a904abe58.png";